import HeroSection from './components/HeroSection';
import WhatSection from './components/WhatSection';
import WhySection from './components/WhySection';
import ImpactSection from './components/ImpactSection';
import JoinSection from './components/JoinSection';
import DonateSection from './components/DonateSection';
import ContactSection from './components/ContactSection';
import Navbar from '../../components/feature/Navbar';
import { useSEO } from '../../utils/seo';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.masdeuna.org';
  
  useSEO({
    title: 'MasDeUna - Latina Leadership Mentorship & Professional Development Movement',
    description: 'MasDeUna is a bold movement elevating Latina leadership through mentorship, advocacy, and economic mobility. Join us in building powerful futures for Latinas in boardrooms, entrepreneurship, and decision-making spaces.',
    keywords: 'Latina leadership, women empowerment, mentorship, Latina entrepreneurs, professional development, MasDeUna',
    canonical: `${siteUrl}/`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'MasDeUna',
      url: siteUrl,
      logo: `${siteUrl}/vite.svg`,
      description: 'A bold movement elevating Latina leadership through mentorship, advocacy, and economic mobility.',
      sameAs: [
        'https://www.julieveloz.com'
      ],
      founder: {
        '@type': 'Person',
        name: 'Adaluz Julie Veloz',
        url: 'https://www.julieveloz.com'
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'General Inquiries',
        url: `${siteUrl}/join`
      }
    }
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <WhatSection />
      <WhySection />
      <ImpactSection />
      <JoinSection />
      <DonateSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;
